import {LinearGradient} from 'expo-linear-gradient';
import i18n from 'i18n-js';
import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';
import {Dimensions, Switch, Text, TouchableOpacity, View} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {
  GetBothSettings,
  UpdateSettings,
  GetGeneralSetting
} from '../../actions/userAction';
import styles from '../../style/directPrinting';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { isHapticsMode } from '../../actions/menuActions';
import ToolTip from './toolTip';
import SettingComponent from './settingComponet';
import PopUpModel from '../scanpack/pop_up_model';
import LanguageToggler from './languageToggler';
import ScanToCart from '../scanToCart/scanToCart';
import SoundSetting from './soundSetting';
import useScanToCartWorkflowEnabled from '../../helpers/useScanToCartWorkflowEnabled';
import CountDownChart from './CountDownChart';
import ScanPackSettingToggle from '../scanToCart/ScanPackSettingToggle';
import PackingCamSetting from './packingcampSetting';
import CamScannerSetting from './camScannerSetting';
import VerbosityToggler from '../../commons/dropDowns/VerbosityToggler';
import TTSToggle from '../../commons/ttsToggle';
import ZoneSettings from '../zoneSettings/zoneSettings';
import RulesSection from '../rulesEngine/RulesSection';
import BoxCatalogSection from '../boxCatalog/BoxCatalogSection';
import LotMetadataReportSection from '../lotMetadataReport/LotMetadataReportSection';

const Settings = props => {
  const dispatch = useDispatch();
  const [popUpModelShow, setPopUpModelShow] = useState(false);
  const [qzErrorMsg, setQzErrorMsg] = useState('');
  const [isLanguageChange, setIsLanguageChange] = useState(false)
  const {bothSettings} = useSelector(state => state.user);
  const {settings} = useSelector(state => state.user);
  const isScanToCartEnabled = useScanToCartWorkflowEnabled();
  const userData = useSelector(state => state.user.userInfo);
  const isRulesManager = userData?.role?.rules_manager === true;
  const isRulesEngineEnabled = userData?.rules_engine_enabled === true;
  const canSeeRulesSection = isRulesManager && isRulesEngineEnabled;
  const canSeeLotMetadataReport = userData?.lot_metadata_archive_enabled === true;
  const updateSettingValue = bothSettings?.data?.data?.general_setting;
  const savedSettings = useRef(updateSettingValue);
  savedSettings.current = updateSettingValue;
  const isBoxChamp = updateSettingValue?.is_box_champ === true;
  const adminSetting = settings?.data?.direct_printing_options;
  const isHaptic = useSelector((state) => state.menu.isHaptics);
  dispatch(isHapticsMode(updateSettingValue?.is_haptics_option))
  const [slidShowTime, setSlidShowTime] = useState(updateSettingValue?.slide_show_time || '10');
  const [switchBtn, setSwitchBtn] = useState({
    print_packing_slips: updateSettingValue?.print_packing_slips,
    print_post_scanning_barcodes:
      updateSettingValue?.print_post_scanning_barcodes,
    print_product_barcode_labels:
      updateSettingValue?.print_product_barcode_labels,
    print_ss_shipping_labels: updateSettingValue?.print_ss_shipping_labels,
    print_product_receiving_labels:
      updateSettingValue?.print_product_receiving_labels,
    is_haptics_option:updateSettingValue?.is_haptics_option
  });

  useEffect(() => {
    handleSlidShowTime(updateSettingValue?.slide_show_time);    
    handleUpdateNewTimeZone(updateSettingValue)
    dispatch(GetBothSettings());
    dispatch(GetGeneralSetting());
  }, []);


  const saveDefaultReceivingLabelDimensions = async () => {
    const defaultDimensions = {
      width: '4',
      height: '6',
      dpi: '0',
    };
    try {
      await AsyncStorage.setItem('receive_recount_Dimensions', JSON.stringify(defaultDimensions));
      console.log('Successfully auto-saved default dimensions:', defaultDimensions);
    } catch (error) {
      console.error('Failed to auto-save default dimensions:', error);
    }
  };

  useEffect(() => {
    if (updateSettingValue?.print_product_receiving_labels) {
      console.log('Auto-saving default dimensions for Product Receiving Labels on load');
      saveDefaultReceivingLabelDimensions()
    }
  }, [updateSettingValue?.print_product_receiving_labels]);

  let packingSlipSize =localStorage.getItem('Packing_slip_size') || '{}';
  let ProductBarcodeLabelSize = localStorage.getItem('Product_Barcode_label_size') || '{}';
  const switchToggle = async (value, key) => {
    setSwitchBtn({...switchBtn, [key]: value});
    const saving = dispatch(UpdateSettings({...switchBtn, [key]: value}));

    if (key === 'print_product_receiving_labels' && value === true) {
      console.log('Auto-saving default dimensions for Product Receiving Labels');
      saveDefaultReceivingLabelDimensions()
    }

    const result = await saving;
    if (!result?.ok) {
      setSwitchBtn(current => ({...current, [key]: savedSettings.current?.[key]}));
      setQzErrorMsg(result?.errorMessages?.[0] || i18n.t('scanPack.settingUpdateFailed'));
    }
  };

  const handleUpdateSlideShowTime = async value => {
    dispatch(UpdateSettings({...switchBtn, ['slide_show_time']: value}));
    handleSlidShowTime(value);
  };

  const handleSlidShowTime = async value => {
    setSlidShowTime(value);
    await AsyncStorage.setItem('slideShowTime', value);
  };
  const handleUpdateNewTimeZone = async value => {
    handleNewTimeZone(value.new_time_zone);
  };
  
  const handleNewTimeZone = async value => {
    await AsyncStorage.setItem('new_time_zone', value);
  };
  

  const alertBox = () => {
    setPopUpModelShow(true)
    setTimeout(
      function () {
        setPopUpModelShow(false)
      }.bind(this),
      4000
    );
  };

  const [windowWidth, setWindowWidth] = useState(
    Dimensions.get('window').width
  );
  const [activeTollTip, setActiveTollTip] = useState('');
  useLayoutEffect(() => {
    function updateSize() {
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  const handleTollTip = (attribute) => {
    if(activeTollTip !== attribute){
     setActiveTollTip(attribute)
     return
    }
    setActiveTollTip('');
  }

  const checkPrinter = async (key) => {
    return (await AsyncStorage.getItem(key)) || ''
  }
  return (
    <>
    {qzErrorMsg !== '' && (
        <PopUpModel
            closeAlert={() => setQzErrorMsg('')}
            message={qzErrorMsg}
            messageTypeSuccess={false}
        />
      )}
    {popUpModelShow && (
        <PopUpModel
            closeAlert={()=>{setPopUpModelShow(false)}}
            message={i18n.t('directprinting.alertForPdfSizeEdit')}
            messageTypeSuccess= {true}
        />
      )}
      <View
        testID="settingContainer"
        style={{
          height: windowWidth >= 900 ? 'calc(100vh - 64px)' : 'calc(100vh - 40px)',
          overflow: 'auto'
        }}
        onStartShouldSetResponder={() => setActiveTollTip('')}>
        <LinearGradient
          colors={[
            '#000',
            '#000',
            '#5c778f',
            '#5c778f',
            '#253c57',
            '#253c57',
            '#000'
          ]}
          start={[-0.5, -1]}
          style={{
            minHeight: '100%',
            paddingBottom: 15
          }}>
          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center'
            }}>
            <View
              style={{
                width: windowWidth >= 900 ? '70%' : '372px',
                paddingTop: '58px',
                paddingBottom: '58px',
                marginTop: '43px',
                borderRadius: '25px',
                display: 'flex',
                alignItems: 'center'
              }}>
              <View style={{width: windowWidth >= 900 ? '530px' : '100%', position: 'relative', zIndex: 1000}}>
                <View
                  style={{
                    display: 'flex',
                    gap: '10px',
                    left: '6%',
                    alignItems: 'center',
                    flexDirection: 'row',
                    paddingBottom: '20px',
                    position: 'relative',
                    zIndex: 7
                  }}>
                  <TouchableOpacity
                    testID="tooltipone"
                    onPress={() => handleTollTip('QuickScanToolTip0')}
                    style={{width: 20}}>
                    <i
                      className="icon-info-circled"
                      style={styles.iconInfo}></i>
                  </TouchableOpacity>
                  <Text style={[styles.subHeading]}>
                    {i18n.t('directprinting.directprintingHead')}
                  </Text>
                  {activeTollTip === 'QuickScanToolTip0' && (
                    <ToolTip
                      // message={i18n.t('directprinting.tooltipDirectPrintinHeading')}
                      testID={'quicKScanToolTipone'}
                      windowWidth={windowWidth}
                      left={'-52%'}
                      top={8}
                      isLink={true}
                    />
                  )}
                </View>

              <View
                style={{
                  display: 'flex',
                  gap: '7px',
                  paddingLeft: windowWidth > 900 ? '20px' : '10'
                }}>
                <SettingComponent
                 testId={'tooltiptwo'}
                 isPrinter={checkPrinter(`user_selected_printer_packing_slip_${packingSlipSize}`)}
                 handleTollTip={(value)=>{handleTollTip(value)}}
                 removeItem={`user_selected_printer_packing_slip_${packingSlipSize}`}
                 switchId={'printPackingSlip'}
                 switchDisabled={!adminSetting}
                 switchToggle={(e,value)=>{switchToggle(e,value)}}
                 switchLabel={'print_packing_slips'}
                 switchValue={updateSettingValue?.print_packing_slips}
                 label={i18n.t('directprinting.packingslipSetting')}
                 activeTollTip={activeTollTip}
                 activeTollTipValue={'QuickScanToolTip'}
                 ToolTipId={'quicKScanToolTiptwo'}
                 ToolTipMessage={i18n.t('directprinting.tooltippacking')}
                 left={'-54%'}
                 top={10}
                 width={windowWidth}
                 zIndex={7}
                 type={"packing_slip"}
                 pdfSize={updateSettingValue?.packing_slip_size}
                 handleEdit={() => {alertBox()}}
                 onQzError={(msg) => setQzErrorMsg(msg)}
                />
                <SettingComponent
                 testId={'tooltipsix'}
                 isPrinter={checkPrinter(`print_product_barcode_labels_${ProductBarcodeLabelSize}`)}
                 handleTollTip={(value)=>{handleTollTip(value)}}
                 removeItem={`print_product_barcode_labels_${ProductBarcodeLabelSize}`}
                 switchId={'printProductBarcode'}
                 switchDisabled={!adminSetting}
                 switchToggle={(e,value)=>{switchToggle(e,value)}}
                 switchLabel={'print_product_barcode_labels'}
                 switchValue={updateSettingValue?.print_product_barcode_labels}
                 label={i18n.t('directprinting.ordernumberbarcode')}
                 activeTollTip={activeTollTip}
                 activeTollTipValue={'QuickScanToolTip5'}
                 ToolTipId={'quicKScanToolTipSix'}
                 ToolTipMessage={i18n.t('directprinting.tooltipOrderBarcode')}
                 left={'-54%'}
                 top={15}
                 width={windowWidth}
                 zIndex={6}
                 type={"product_barcode"}
                 pdfSize={settings?.data?.data?.settings.product_barcode_label_size}
                 handleEdit={() => {alertBox()}}
                 onQzError={(msg) => setQzErrorMsg(msg)}
                />
                <SettingComponent
                 testId={'tooltipFour'}
                 isPrinter={checkPrinter('print_ss_shipping_labels')}
                 handleTollTip={(value)=>{handleTollTip(value)}}
                 removeItem={'print_ss_shipping_labels'}
                 switchId={'printSSLabel'}
                 switchDisabled={!adminSetting}
                 switchToggle={(e,value)=>{switchToggle(e,value)}}
                 switchLabel={'print_ss_shipping_labels'}
                 switchValue={updateSettingValue?.print_ss_shipping_labels}
                 label={i18n.t('directprinting.shippiglabel')}
                 activeTollTip={activeTollTip}
                 activeTollTipValue={'QuickScanToolTip3'}
                 ToolTipId={'quicKScanToolTipFour'}
                 ToolTipMessage={i18n.t('directprinting.tooltipShipping')}
                 left={'-54%'}
                 top={17}
                 width={windowWidth}
                 zIndex={5}
                 type={"shipping_label"}
                 handleEdit={() => {alertBox()}}
                 onQzError={(msg) => setQzErrorMsg(msg)}
                 isShipping={true}
                />
                <SettingComponent
                 testId={'tooltipthree'}
                 isPrinter={checkPrinter('user_selected_printer_order_barcode_label')}
                 handleTollTip={(value)=>{handleTollTip(value)}}
                 removeItem={'user_selected_printer_order_barcode_label'}
                 switchId={'printOrderBarcode'}
                 switchDisabled={!adminSetting}
                 switchToggle={(e,value)=>{switchToggle(e,value)}}
                 switchLabel={'print_post_scanning_barcodes'}
                 switchValue={updateSettingValue?.print_post_scanning_barcodes}
                 label={i18n.t('directprinting.productBarcode')}
                 activeTollTip={activeTollTip}
                 activeTollTipValue={'QuickScanToolTipProduct'}
                 ToolTipId={'quicKScanToolTipThree'}
                 ToolTipMessage={i18n.t('directprinting.tooltipBarcode')}
                 left={'-54%'}
                 top={17}
                 width={windowWidth}
                 zIndex={4}
                 type={"order_barcode"}
                 pdfSize={'1 x 3'}
                 handleEdit={() => {alertBox()}}
                 onQzError={(msg) => setQzErrorMsg(msg)}
                />
                <SettingComponent
                 testId={'tooltipfive'}
                 isPrinter={checkPrinter('user_receive_label')}
                 handleTollTip={(value)=>{handleTollTip(value)}}
                 removeItem={'user_receive_label'}
                 switchId={'printReceiveRecount'}
                 switchDisabled={!adminSetting}
                 switchToggle={(e,value)=>{switchToggle(e,value)}}
                 switchLabel={'print_product_receiving_labels'}
                 switchValue={updateSettingValue?.print_product_receiving_labels}
                 label={i18n.t('directprinting.receiveRecountLabel')}
                 activeTollTip={activeTollTip}
                 activeTollTipValue={'QuickScanToolTip4'}
                 ToolTipId={'quicKScanToolTipFive'}
                 ToolTipMessage={i18n.t('directprinting.tooltipReceivingPrinting')}
                 left={'-52%'}
                 top={15}
                 width={windowWidth}
                 zIndex={2}
                 type={"receive_recount"}
                 isReceiver={true}
                 handleEdit={() => {alertBox()}}
                 onQzError={(msg) => setQzErrorMsg(msg)}
                />
              </View>
              <View
                style={{
                  display: 'flex',
                  gap: '10px',
                  left: '6%',
                  alignItems: 'center',
                  flexDirection: 'row',
                  paddingBottom: '20px',
                  position: 'relative',
                  zIndex: -1,
                  marginTop: 20
                }}>
                <Text style={[styles.subHeading]}>
                  {i18n.t('directprinting.otherOptions')}
                </Text>
              </View>
              <View
                style={{
                  display: 'flex',
                  gap: '7px',
                  zIndex: -1,
                  paddingLeft: windowWidth > 900 ? '20px' : '10'
                }}>
                  <View
                    style={{
                      display: 'flex',
                      gap: '15px',
                      alignItems: 'center',
                      flexDirection: 'row',
                      position: 'relative'
                    }}>
                    <TouchableOpacity
                      style={{width: 20, zIndex: 99}}
                      testID="tooltipHaptics"
                      onPress={() => handleTollTip('tooltipHaptics')}>
                      <i
                        className="icon-info-circled"
                        style={styles.iconInfo}></i>
                    </TouchableOpacity>
                    <TouchableOpacity
                      testID="removeHaptics"
                      onPress={() => switchToggle(false, 'is_haptics_option')}>
                      <LinearGradient
                        colors={['#7BFAC3', '#1CBB77']}
                        locations={[0.1, 0.9]}
                        style={[styles.greenButton]}>
                        <Text>RESET</Text>
                      </LinearGradient>
                    </TouchableOpacity>
                    <Switch
                      testID="hapticsFeedback"
                      offColor="#5c6e79"
                      onColor="##5AA6D1"
                      offHandleColor="#969696"
                      onHandleColor="#fbfdfe"
                      handleDiameter={22}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      height={20}
                      width={40}
                      value={isHaptic}
                      onValueChange={e => {
                        switchToggle(e, 'is_haptics_option');
                      }}
                    />
                    <Text
                      style={{
                        color: 'white',
                        fontSize: '16px',
                        fontWeight: 300
                      }}>
                      {i18n.t('directprinting.hapticsLable')}
                    </Text>
                    {activeTollTip === 'tooltipHaptics' && (
                      <ToolTip
                        message={i18n.t('directprinting.tooltipHaptics')}
                        testID={'tooltipHaptics'}
                        windowWidth={windowWidth}
                        left={'-54%'}
                        top={58}
                        bodyTop={-50}
                      />
                    )}
                  </View>
                </View>
                {settings?.data?.packing_cam &&
                  settings?.data?.post_scanning_config?.modules?.includes('packing_cam') && (
                  <PackingCamSetting windowWidth={windowWidth} />
                )}
                <CamScannerSetting windowWidth={windowWidth} />
                <LanguageToggler setIsLanguageChange={setIsLanguageChange} />
                {settings?.data?.voice_packing && <VerbosityToggler
                  activeTollTip={activeTollTip} 
                  handleTollTip={handleTollTip} 
                />}
                {settings?.data?.voice_packing && <TTSToggle />}
                <CountDownChart
                  time={slidShowTime}
                  onClick={value => {
                    handleUpdateSlideShowTime(value);
                  }}
                />
                <View style= {{position: 'relative', zIndex: 1000 , paddingBottom: 10}}>
                  <ScanPackSettingToggle
                    settingKey="include_action_required_orders"
                    labelKey="scanToCart.includeActionRequiredOrders"
                    tooltipKey="scanToCart.includeActionRequiredOrdersTooltip"
                    testID="includeActionRequiredOrders"
                    activeTollTip={activeTollTip}
                    handleTollTip={handleTollTip}
                  />
                </View>
                <View style= {{position: 'relative', zIndex: 999 , paddingBottom: 10}}>
                  <ScanPackSettingToggle
                    settingKey="suppress_software_keyboard"
                    labelKey="directprinting.suppressSoftwareKeyboard"
                    tooltipKey="directprinting.suppressSoftwareKeyboardTooltip"
                    testID="suppressSoftwareKeyboard"
                    activeTollTip={activeTollTip}
                    handleTollTip={handleTollTip}
                    activeTollTipValue="suppressSoftwareKeyboardTooltip"
                  />
                </View>
              </View>
              {isScanToCartEnabled && <View style={{ width: windowWidth < 1200 ? '130%' : '100%' }}>
                <ScanToCart />
              </View>
              }
              <View style={{marginTop: 20}}>
                <SoundSetting />
              </View>
              {canSeeRulesSection && (
                <View style={{ width: windowWidth < 768 ? '100%' : windowWidth < 1200 ? '90%' : '90%', marginTop: 20 }}>
                  <RulesSection />
                </View>
              )}
              {isBoxChamp && (
                <View style={{ width: windowWidth < 768 ? '100%' : windowWidth < 1200 ? '90%' : '90%', marginTop: 20, position: 'relative', zIndex: 10 }}>
                  <BoxCatalogSection activeTollTip={activeTollTip} handleTollTip={handleTollTip} />
                </View>
              )}
              <View style={{ width: windowWidth < 768 ? '100%' : windowWidth < 1200 ? '130%' : '100%', marginTop: 20 }}>
                <ZoneSettings />
              </View>
              {canSeeLotMetadataReport && (
                <View style={{ width: windowWidth < 768 ? '100%' : windowWidth < 1200 ? '130%' : '100%', marginTop: 20 }}>
                  <LotMetadataReportSection />
                </View>
              )}
            </View>
          </View>
        </LinearGradient>
      </View>
    </>
  );
};

export default Settings;
